<div class="log-container d-flex flex-column text-grey">
  <div class="search-bar">
    <input 
      class="search" 
      [value]="searchTerm$.value"
      (input)="onSearchChange($event.target.value)" 
      placeholder="Search logs..."
      debounce="300">
    <button 
      type="button" 
      class="actionBtn" 
      (click)="onLogsDownload()" 
      container="body"
      triggers="hover" 
      ngbTooltip="Download SyncHPC Logs.">
      <span class="bi bi-download"></span>
    </button>
  </div>
  
  <div 
    class="log-content smooth-scroll" 
    #logContent 
    (mouseenter)="onMouseEnter()" 
    (mouseleave)="onMouseLeave()"
    (scroll)="onScroll($event)">
    
    <div 
      *ngFor="let line of filteredLogs$ | async; trackBy: trackByIndex" 
      [innerHTML]="highlightSearchTerm(line)"
      class="log-line">
    </div>
  </div>
</div>